import { render, staticRenderFns } from "./EstruturaConteudo.vue?vue&type=template&id=ec5aa78e"
import script from "./EstruturaConteudo.vue?vue&type=script&lang=js"
export * from "./EstruturaConteudo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports